import {
  ArrowRightStartOnRectangleIcon,
  ChevronDownIcon,
} from "@heroicons/react/24/outline";
import React from "react";
import { useNavigate } from "react-router-dom";
import { ROUTE_LOGIN } from "../../constants/routes";
import { useAppDispatch } from "../../redux/hooks";
import { useGetUserQuery } from "../../redux/services/user";
import { logout } from "../../redux/slices/authSlice";
import Avatar from "../common/Avatar";
import Button from "../form/Button";
import Dropdown from "../form/Dropdown";

const UserMenu = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { data: user } = useGetUserQuery();

  if (!user) {
    return null;
  }

  const handleLogout = () => {
    dispatch(logout());
    navigate(ROUTE_LOGIN, { replace: true });
  };

  const { firstName, lastName, email, profilePictureUrl } = user;

  return (
    <div className="ml-auto mr-2">
      <Dropdown
        button={
          <Button
            variant="icon"
            className="flex items-center gap-2"
            onClick={() => {}}
          >
            <Avatar
              round
              alt={firstName}
              name={`${firstName} ${lastName}`}
              src={profilePictureUrl}
              size="30px"
            />
            <ChevronDownIcon className="h-4 w-4 text-gray-500" />
          </Button>
        }
        menuHeader={
          <div className="px-4 py-4 border-b flex items-center gap-2 max-w-72 w-72">
            <Avatar
              round
              name={`${firstName} ${lastName}`}
              src={profilePictureUrl}
              size="40px"
            />
            <div className="flex flex-col max-w-60">
              <div className="truncate font-medium">
                {firstName} {lastName}
              </div>
              <div className="text-sm text-gray-700 truncate">{email}</div>
            </div>
          </div>
        }
        menuItems={[
          {
            key: "logout",
            label: "Logout",
            icon: (
              <ArrowRightStartOnRectangleIcon className="size-5 text-gray-600" />
            ),
          },
        ]}
        onClick={(key) => {
          if (key === "logout") {
            handleLogout();
          }
        }}
      />
    </div>
  );
};

export default UserMenu;
